import React from 'react';

import { LoadingSpinner } from '../../../../LoadingSpinner/LoadingSpinner';

export const PostsViewerSpinner = () => {
  return (
    <div className="flex size-full items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};
